export const RENT_ROLL_SCHEDULE_TYPE = 'rent-roll';
export function rentalRentOf(model) {
    const occupancy = model.occupancyPercent / 100;
    const kept = model.creditLossPercent === null ? 1 : 1 - model.creditLossPercent / 100;
    const byLine = new Map();
    for (const unit of model.units) {
        const key = `${unit.taxonomy.category}\u0000${unit.taxonomy.subcategory}`;
        const line = byLine.get(key) ?? { taxonomy: unit.taxonomy, potential: 0 };
        byLine.set(key, { ...line, potential: line.potential + (unit.rentBasis.monthlyAmount ?? 0) });
    }
    const grossPotentialRent = [...byLine.values()].reduce((sum, line) => sum + line.potential, 0);
    const occupiedRent = grossPotentialRent * occupancy;
    const creditLoss = model.creditLossPercent === null ? 0 : -occupiedRent * (model.creditLossPercent / 100);
    return {
        grossPotentialRent,
        occupiedRent,
        creditLoss,
        effectiveGrossRent: occupiedRent + creditLoss,
        lines: [...byLine.values()].map(({ taxonomy, potential }) => ({
            taxonomy,
            monthlyAmount: potential * occupancy * kept,
        })),
    };
}
export function rentalRentModelOf(summary) {
    return {
        units: summary.units,
        occupancyPercent: summary.occupancy.effectivePercent,
        creditLossPercent: summary.creditLoss.percent,
    };
}
//# sourceMappingURL=rentalRent.js.map